import React from 'react';
import Color from 'color';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number | string;
  startGradient?: string;
  endGradient?: string;
  className?: string;
}

export const BackgroundDecoration3: React.FC<Props> = ({
  width = 100,
  startGradient = colors.primary,
  endGradient = Color(colors.primary).lighten(0.5).hex(),
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 935 734"
    width={width}
    height={typeof width === 'number' ? width * (734 / 935) : 'auto'}
    className={className}
  >
    <path
      fill="url(#a)"
      d="M0 0h935v734H0z"
    />
    <mask
      id="c"
      width={934}
      height={734}
      x={1}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="url(#b)"
        d="M1.868.409H935v733.183H1.868z"
      />
    </mask>
    <g
      filter="url(#d)"
      mask="url(#c)"
    >
      <rect
        width={873.779}
        height={802.996}
        fill="url(#e)"
        rx={47}
        transform="matrix(.87941 .47606 -.6593 .75188 710.034 -472.938)"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={172.317}
        x2={501.466}
        y1={188.383}
        y2={650.195}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={468.434}
        x2={1023.62}
        y1={0.409}
        y2={658.866}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="e"
        x1={161.034}
        x2={535.808}
        y1={206.091}
        y2={655.265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <filter
        id="d"
        width={1381.91}
        height={1113.37}
        x={138.578}
        y={-519.756}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={31.35} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_299_3011"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_299_3011"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
